import * as React from "react";
import type { SVGProps } from "react";
const SvgMap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m15.544 20.838 5.896-2.948c.34-.17.55-.51.55-.89V4c0-.35-.18-.67-.47-.85s-.66-.19-.97-.04l-5.56 2.78-5.445-2.728a.99.99 0 0 0-1.047-.026L2.55 6.11C2.21 6.28 2 6.62 2 7v13a1 1 0 0 0 1 1c.16 0 .31-.04.45-.11L9 18.11l5.498 2.754a.99.99 0 0 0 1.046-.026M14 18.389l-4-2.003V5.62l4 2zm2 .001V7.624l4-2.004v10.77zM4 7.62l4-2v10.756L4 18.38z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMap;
